import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.loadAvailableMonths()
  }

  async loadAvailableMonths() {
    try {
      const response = await fetch('/disparo/available_months')
      const months = await response.json()

      const select = this.element
      const currentValue = select.value

      // Manter opção "Todos"
      select.innerHTML = '<option value="">Todos os períodos</option>'

      // Adicionar meses disponíveis
      months.forEach(month => {
        const option = document.createElement('option')
        option.value = `${month.year}-${month.month}`
        option.textContent = month.label

        // Verificar se este é o mês selecionado
        const urlParams = new URLSearchParams(window.location.search)
        const selectedYear = urlParams.get('year')
        const selectedMonth = urlParams.get('month')
        if (selectedYear && selectedMonth && selectedYear === month.year.toString() && selectedMonth === month.month.toString()) {
          option.selected = true
        }

        select.appendChild(option)
      })
    } catch (error) {
      console.error('Error loading available months:', error)
    }
  }

  changeMonth(event) {
    const value = event.target.value
    const url = new URL(window.location)

    if (value === "") {
      // Remover filtros de mês e status
      url.searchParams.delete('year')
      url.searchParams.delete('month')
      url.searchParams.delete('status')
    } else {
      // Adicionar filtro de mês e remover status
      const [year, month] = value.split('-')
      url.searchParams.set('year', year)
      url.searchParams.set('month', month)
      url.searchParams.delete('status')
    }

    // Usar Turbo se disponível, senão usar navegação normal
    if (typeof Turbo !== 'undefined') {
      Turbo.visit(url.toString())
    } else {
      window.location.href = url.toString()
    }
  }
}
